import { useEffect, useState } from 'react';
import { TableCollapseCustom } from '../../component/table/table-collapse/TableCollapseCustom';
import { COLUMN_BANG_LAY_MAU } from '../constants';
import { usePhanHeLayMauContext } from '../context/PhanHeLayMauContext';

const BangLayMauBenhPham = (props: any) => {
	const { phieuLayMauInfo } = usePhanHeLayMauContext();
	const [dataKQ, setDataKQ] = useState<any>([]);  

	useEffect(() => {
		setDataKQ(phieuLayMauInfo?.danhSachMau || []);
	}, [phieuLayMauInfo?.danhSachMau]);

	return (
		<>
			<TableCollapseCustom
				columns={COLUMN_BANG_LAY_MAU}
				data={dataKQ || []}
				className="overflow-auto spaces h-calc-vh-305"
				classNameTable="spaces W-1000"
				childrenField="subs"
				isFromTabXN
				isOtherColorHeader
			/>
		</>
	);
};

export default BangLayMauBenhPham;
